import React, { Component } from 'react'
import { Step, Sticky } from 'semantic-ui-react'

class ApplicationSteps extends Component {
    state = {};

    handleContextRef = contextRef => this.setState({ contextRef });

    render() {
        const { step, contextRef, status } = this.props;

        return (

            <Sticky context={contextRef} offset={100}>
            <Step.Group ordered size='mini' vertical style={{marginLeft: '3em'}}>
                <Step active={step === 1} completed={step > 1}>
                    <Step.Content>
                        <Step.Title>Coverage</Step.Title>
                    </Step.Content>
                </Step>
                <Step active={step === 2} completed={step > 2}>
                    <Step.Content>
                        <Step.Title>Contact Info</Step.Title>
                    </Step.Content>
                </Step>
                <Step active={step === 3} completed={step > 3}>
                    <Step.Content>
                        <Step.Title>Type Of User</Step.Title>
                    </Step.Content>
                </Step>
                <Step active={step === 4} completed={step > 4}>
                    <Step.Content>
                        <Step.Title>Mutual Companies</Step.Title>
                    </Step.Content>
                </Step>

                <Step active={step === 5} completed={step > 5}>
                    <Step.Content>
                        <Step.Title>Quarter</Step.Title>
                    </Step.Content>
                </Step>
                <Step active={step === 6} completed={step > 6}>
                    <Step.Content>
                        <Step.Title>Class & Wage</Step.Title>
                    </Step.Content>
                </Step>
                <Step active={step === 7} completed={status === 'SUBMITTED'}>
                    <Step.Content>
                        <Step.Title>Sign & Submit</Step.Title>
                    </Step.Content>
                </Step>
            </Step.Group>
            </Sticky>
        );
    }
}

export default ApplicationSteps